var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegalStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_900_7586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5154 42.7343L33.9841 29.6093C36.5623 26.1718 37.8123 21.9531 37.656 17.5781C37.2654 8.12497 29.8435 0.390597 20.3904 -0.390653C14.4529 -0.859403 8.67165 1.48435 4.7654 5.85935C1.17165 9.92185 -0.468979 15.1562 0.156021 20.625C1.24977 30.0781 9.29665 37.1875 18.9841 37.1875C22.8123 37.1875 26.4841 36.0156 29.531 33.9062L42.1873 48.8281C43.0466 49.8437 44.2966 50.3906 45.6248 50.3906C46.7966 50.3906 47.8904 49.9218 48.6716 49.1406C49.531 48.2812 50.0779 47.1093 49.9998 45.8593C49.9998 44.6875 49.4529 43.5156 48.5154 42.7343ZM5.62477 6.6406C9.29665 2.49997 14.7654 0.312472 20.3123 0.781222C29.1404 1.48435 36.0935 8.74997 36.4841 17.5781C36.5623 18.5156 36.4841 19.5312 36.3279 20.4687H29.6091L27.1873 10.2343L24.6091 18.8281H18.281L16.0154 26.0937L11.9529 8.28122L8.59352 18.6718H1.09352C1.09352 14.2187 2.65602 9.99997 5.62477 6.6406ZM47.8123 48.3593C47.1873 48.9843 46.406 49.2968 45.5466 49.2968C44.6091 49.2968 43.6716 48.9062 43.0466 48.125L29.6873 32.3437L29.2185 32.6562C26.2498 34.8437 22.656 36.0156 18.8279 36.0937C9.84352 36.0156 2.34352 29.375 1.3279 20.5468C1.3279 20.3125 1.24977 20.0781 1.24977 19.8437H9.53102L11.7966 12.7343L15.8591 30.625L19.2185 20.0781H25.5466L27.1091 14.8437L28.7498 21.7968H36.1716C35.6248 24.5312 34.4529 27.1875 32.7341 29.375L32.4216 29.7656L47.8123 43.5937C48.5154 44.2187 48.906 45.0781 48.906 45.9375C48.8279 46.875 48.5154 47.7343 47.8123 48.3593Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2497 42.4802L42.0737 43.3134L42.9069 42.4894L42.0829 41.6561L41.2497 42.4802Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6081 45.8583L45.4321 46.6915L46.2653 45.8674L45.4413 45.0342L44.6081 45.8583Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9313 44.1695L43.7554 45.0027L44.5886 44.1786L43.7645 43.3454L42.9313 44.1695Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_900_7586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalStatus);
export default __webpack_public_path__ + "static/media/legalStatus.9dda98956ad4441df933db16528d9089.svg";
export { ForwardRef as ReactComponent };